import { render, staticRenderFns } from "./RemoteController.vue?vue&type=template&id=5f0b0d1d&scoped=true&"
import script from "./RemoteController.vue?vue&type=script&lang=js&"
export * from "./RemoteController.vue?vue&type=script&lang=js&"
import style0 from "./RemoteController.vue?vue&type=style&index=0&id=5f0b0d1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b0d1d",
  null
  
)

export default component.exports